export default "__VITE_ASSET__BzhOscVk__"